import antdSA from 'antd/lib/locale-provider/ca_ES';
import saMessages from '../locales/nl_NL.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  antd: antdSA,
  locale: 'nl',
};
export default saLang;
